import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M14.25 19.25L18 19.25C18.6904 19.25 19.25 18.6904 19.25 18L19.25 14.5M14.25 19.25L6 19.25C5.30964 19.25 4.75 18.6904 4.75 18L4.75 6C4.75 5.30964 5.30965 4.75 6 4.75L14.25 4.75M14.25 19.25L14.25 14.5M14.25 4.75L18 4.75C18.6904 4.75 19.25 5.30964 19.25 6L19.25 9.5M14.25 4.75L14.25 9.5M14.25 9.5L19.25 9.5M14.25 9.5L14.25 14.5M19.25 9.5L19.25 14.5M14.25 14.5L19.25 14.5" />
		<Path d="M6.5 12L9.5 12M12.5 12L9.5 12M9.5 12L9.5 15M9.5 12L9.5 9" />
	</SVG>
);
